const EmptyImage = ()=>{
  return (
    <img src="/images/no-image.png" className={"width_full"} alt=""/>
  );
}
export default EmptyImage;